import React, { useEffect } from "react";
import { questionTypes } from "../../../utils/constants";

const SliderPointers = () => {
  return (
    <span className="text-sm text-lightGrey">Please slide the slider(s) to change a value or enter a value in the text box.</span>
  )
}

const QuestionWrapper = ({
  // question,
  // setAnswer = () => {},
  questionDetails,
  setQuestionDetails,
}) => {
  // console.log("🚀 ~ questionDetails:", questionDetails);
  // const [rangeValue, setRangeValue] = React.useState(0);

  useEffect(() => {
    if (questionDetails?.answer && questionDetails?.answer !== "") return;

    if (questionDetails?.question.type === questionTypes["number"]) {
      // setAnswer(0);
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: 0,
      }));
    }

    if (questionDetails?.question.type === questionTypes["range"]) {
      // setAnswer(0);
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: 0,
      }));
    }

    if (questionDetails?.question.type === questionTypes["mcq"]) {
      // setAnswer("");
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: "",
      }));
    }

    if (questionDetails?.question.type === questionTypes["text"]) {
      // setAnswer("");
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: "",
      }));
    }

    if (questionDetails?.question.type === questionTypes["checkbox"]) {
      // setAnswer("");
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: "",
      }));
    }

    if (questionDetails?.question.type === questionTypes["multipleRange"]) {
      const initialRanges = questionDetails?.question?.options?.map(range => ({
        key: range.value || '',
        value: 0
      })) || [];
      // console.log("🚀 ~ initialRanges ~ initialRanges:", initialRanges)
      setQuestionDetails((prevData) => ({
        ...prevData,
        answer: initialRanges,
      }));
    }
  }, [questionDetails?.answer]);


  return (
    <div className="flex flex-col question-css">
      <label className="font-medium text-base md:text-lg relative">
        {`${questionDetails?.questNumber}: ${questionDetails?.question.question_text}`}
      </label>
      <div className="mt-3 md:mt-4 flex flex-col gap-2 md:gap-3">
        {/* Multiple Range Input */}
        {questionDetails?.question?.type === questionTypes["multipleRange"] && (
          <div className="flex flex-col gap-4">
            {questionDetails?.question?.options?.map((range, index) => {
              const currentValue = parseFloat(questionDetails?.answer?.[index]?.value) || 0;

              return (
                <div key={index} className="flex flex-col gap-1 mt-1">
                  <label className="text-sm font-medium text-gray-700">
                    {range.value}
                  </label>
                  <div className="flex flex-col md:flex-row gap-3 md:gap-4 items-start md:items-center">
                    <input
                      type="range"
                      min={0}
                      max={100}
                      className="w-full md:w-72 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer range-slider"
                      value={currentValue}
                      style={{
                        background: `linear-gradient(to right, #006a2d 0%, #006a2d ${currentValue}%, #e5e7eb ${currentValue}%, #e5e7eb 100%)`
                      }}
                      onChange={(e) => {
                        const newValue = parseFloat(e.target.value);
                        setQuestionDetails((prevData) => {
                          const currentAnswers = [...(prevData.answer || [])];
                          const otherValuesSum = currentAnswers.reduce((sum, item, idx) =>
                            idx !== index ? sum + (parseFloat(item?.value) || 0) : sum, 0);

                          const maxAllowed = 100 - otherValuesSum;
                          const adjustedValue = Math.min(newValue, maxAllowed);

                          currentAnswers[index] = {
                            key: range.value,
                            value: adjustedValue
                          };

                          return {
                            ...prevData,
                            answer: currentAnswers,
                          };
                        });
                      }}
                    />
                    <input
                      type="number"
                      min={0}
                      max={100}
                      className="border p-2 rounded h-10 w-20 text-sm md:text-base focus:ring-2 focus:ring-darkGreen focus:border-transparent"
                      value={currentValue}
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        if (inputValue === "") {
                          setQuestionDetails((prevData) => {
                            const newAnswer = [...(prevData.answer || [])];
                            newAnswer[index] = {
                              key: range.value,
                              value: 0
                            };
                            return {
                              ...prevData,
                              answer: newAnswer,
                            };
                          });
                          return;
                        }

                        let finalValue = parseFloat(inputValue);

                        setQuestionDetails((prevData) => {
                          const currentAnswers = [...(prevData.answer || [])];
                          const otherValuesSum = currentAnswers.reduce((sum, item, idx) =>
                            idx !== index ? sum + (parseFloat(item?.value) || 0) : sum, 0);

                          if (isNaN(finalValue)) finalValue = 0;
                          if (finalValue < 0) finalValue = 0;

                          const maxAllowed = 100 - otherValuesSum;
                          finalValue = Math.min(finalValue, maxAllowed);

                          currentAnswers[index] = {
                            key: range.value,
                            value: finalValue
                          };

                          return {
                            ...prevData,
                            answer: currentAnswers,
                          };
                        });
                      }}
                    />
                  </div>
                </div>
              );
            })}
            <div className="flex justify-between items-center text-sm text-lightGrey">
              <span>Total: {questionDetails?.answer ?
                questionDetails.answer.reduce((sum, item) => sum + (parseFloat(item?.value) || 0), 0)
                : 0}%</span>
              <span>Maximum: 100%</span>
            </div>
            <SliderPointers />
          </div>
        )}

        {/* MCQ Options */}
        {questionDetails?.question?.type === questionTypes["mcq"] && questionDetails?.question?.options &&
          questionDetails?.question?.options?.map((option, i) => (
            <span key={i} className="p-2 group/radio">
              <input
                type="radio"
                id={`question1-option-${i}`}
                name="question1"
                value={option?.value}
                defaultChecked={questionDetails?.answer === option?.value}
                className="cursor-pointer w-4 h-4"
                onChange={(e) => {
                  setQuestionDetails((prevData) => ({
                    ...prevData,
                    answer: e.target.value,
                  }));
                }}
              />
              <label
                htmlFor={`question1-option-${i}`}
                className="pl-2 cursor-pointer text-sm md:text-base"
              >
                {questionDetails?.
                  question?.order === 1 && option?.value === 'Asian' ? 'Asian (e.g., East Asian, South Asian, Southeast Asian)' : option?.value}
              </label>
            </span>
          ))}

        {/* Text Input */}
        {questionDetails?.question?.type === questionTypes["text"] && (
          <textarea
            cols={10}
            rows={4}
            id={`question1-option-${questionDetails?.questNumber}`}
            name="question1"
            className="border p-2 md:p-3 rounded text-sm md:text-base resize-none focus:ring-2 focus:ring-darkGreen focus:border-transparent"
            value={questionDetails?.answer}
            onChange={(e) =>
              setQuestionDetails((prevData) => ({
                ...prevData,
                answer: e.target.value,
              }))
            }
          />
        )}

        {/* Number Input */}
        {questionDetails?.question?.type === questionTypes["number"] && (
          <div className="flex flex-col gap-2">
            <input
              type="number"
              id={`question1-option-${questionDetails?.questNumber}`}
              name="question1"
              min={questionDetails?.question?.min_range}
              max={questionDetails?.question?.max_range}
              value={questionDetails?.answer}
              className="border p-2 md:p-3 rounded h-10 w-full md:w-72 text-sm md:text-base focus:ring-2 focus:ring-darkGreen focus:border-transparent"
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue === "") {
                  setQuestionDetails((prevData) => ({
                    ...prevData,
                    answer: "",
                  }));
                } else {
                  // Convert to string first to handle leading zeros
                  const strValue = inputValue.toString();
                  // Remove leading zeros but keep single zero
                  const cleanValue = strValue.replace(/^0+(?=\d)/, '');
                  const numValue = parseInt(cleanValue);
                  if (numValue <= 0) {
                    setQuestionDetails((prevData) => ({
                      ...prevData,
                      answer: 0,
                    }));
                  } else if (questionDetails?.question?.max_range && numValue > (questionDetails?.question?.max_range)) {
                    setQuestionDetails((prevData) => ({
                      ...prevData,
                      answer: questionDetails?.question?.max_range,
                    }));
                  } else {
                    setQuestionDetails((prevData) => ({
                      ...prevData,
                      answer: cleanValue, // Store as string to preserve input exactly
                    }));
                  }
                }
              }}
              onScroll={(value) => {
                value.preventDefault();
              }}
            />
            {typeof questionDetails?.question?.min_range === "number" && (
              <span className="text-sm text-lightGrey">
                Minimum: {questionDetails?.question?.min_range}
              </span>
            )}
            {questionDetails?.question?.max_range && (
              <span className="text-sm text-lightGrey">
                Maximum: {questionDetails?.question?.max_range}
              </span>
            )}
          </div>
        )}

        {/* Range Input */}
        {questionDetails?.question?.type === questionTypes["range"] && (
          <div className="flex flex-col gap-2">
            <div className="flex flex-col md:flex-row gap-3 md:gap-4 items-start md:items-center">
              <input
                type="range"
                id={`question1-option-${questionDetails?.questNumber}`}
                name="question1"
                min={questionDetails?.question?.min_range ?? 0}
                max={questionDetails?.question?.max_range ?? 100}
                className="w-full md:w-72 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer range-slider"
                value={questionDetails?.answer}
                style={{
                  background: `linear-gradient(to right, #006a2d 0%, #006a2d ${questionDetails?.answer}%, #e5e7eb ${questionDetails?.answer}%, #e5e7eb 100%)`
                }}
                onChange={(e) => {
                  setQuestionDetails((prevData) => ({
                    ...prevData,
                    answer: e.target.value,
                  }));
                }}
              />
              <input
                type="number"
                id={`question1-option-${questionDetails?.questNumber}`}
                name="question1"
                min={0}
                max={100}
                className="border p-2 rounded h-10 w-20 text-sm md:text-base focus:ring-2 focus:ring-darkGreen focus:border-transparent"
                value={questionDetails?.answer}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue === "") {
                    setQuestionDetails((prevData) => ({
                      ...prevData,
                      answer: "",
                    }));
                  } else {
                    // Convert to string first to handle leading zeros
                    const strValue = inputValue.toString();
                    // Remove leading zeros but keep single zero
                    const cleanValue = strValue.replace(/^0+(?=\d)/, '');
                    const numValue = parseInt(cleanValue);

                    if (numValue <= 0) {
                      setQuestionDetails((prevData) => ({
                        ...prevData,
                        answer: 0,
                      }));
                    } else if (numValue > (questionDetails?.question?.max_range)) {
                      setQuestionDetails((prevData) => ({
                        ...prevData,
                        answer: questionDetails?.question?.max_range,
                      }));
                    } else {
                      setQuestionDetails((prevData) => ({
                        ...prevData,
                        answer: cleanValue, // Store as string to preserve input exactly
                      }));
                    }
                  }
                }}
                onScroll={(value) => {
                  value.preventDefault();
                }}
              />
            </div>
            {typeof questionDetails?.question?.min_range === "number" && (
              <span className="text-sm text-lightGrey">
                Minimum: {questionDetails?.question?.min_range}
              </span>
            )}

            {questionDetails?.question?.max_range && (
              <span className="text-sm text-lightGrey">
                Maximum: {questionDetails?.question?.max_range}
              </span>
            )}
            <SliderPointers />

          </div>
        )}

        {/* Checkbox Options */}
        {questionDetails?.question?.type === questionTypes["checkbox"] &&
          questionDetails?.question?.options?.map((option, i) => (
            <span key={i} className="p-2 group/checkbox">
              <input
                type="checkbox"
                id={`question1-option-${i}`}
                name="question1"
                // value={option}
                value={option?.value}
                checked={questionDetails?.answer ? questionDetails?.answer?.findIndex((item) => item?.value === option?.value) !== -1 : false}
                className="cursor-pointer w-4 h-4"
                onChange={(e) => {
                  setQuestionDetails((prevData) => {

                    const udpatedAnswer = e.target.checked
                      ? prevData?.answer && prevData?.answer !== '' ? [...prevData.answer, option] : [option]
                      : prevData.answer.filter((item) => item?.value !== e.target.value)

                    const removeMultiple = udpatedAnswer.filter((item, index) => {
                      return udpatedAnswer.findIndex((item2) => item2.value === item.value) === index;
                    }
                    );

                    return ({
                      ...prevData,
                      answer: removeMultiple,
                    })
                  });
                }}
              />
              <label
                htmlFor={`question1-option-${i}`}
                className="pl-2 cursor-pointer text-sm md:text-base"
              >
                {/* {option} */}
                {option?.value}
              </label>
            </span>
          ))}
      </div>
    </div>
  );
};

export default QuestionWrapper;
